// リンク
import React from 'react';
var Link = function (_a) {
    var display_name = _a.display_name, anchor = _a.anchor, color = _a.color, bold = _a.bold, css_class = _a.css_class;
    // 太字の設定
    var bold_css = typeof bold !== 'undefined' && bold === true ? 'link-font-bold' : '';
    // 色の規定値
    if (typeof color === 'undefined') {
        color = 'blue';
    }
    // CSSクラスの規定値
    if (typeof css_class === 'undefined') {
        css_class = '';
    }
    return (React.createElement("a", { href: anchor, className: "link-text " + color + " " + css_class + " " + bold_css, target: "_blank" }, display_name));
};
export default Link;
